// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents inobtained
// from Xngage LLC.
//

import { imageBadgeStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsImageBadge";
import { css } from "styled-components";

imageBadgeStyles.container = {
    css: css`
        &:empty,
        &:has(> div:empty) {
            display: none;
        }
        & img {
            max-width: 100%;
            height: auto;
            max-height: 100%;
        }
    `,
};
imageBadgeStyles.imageContainer = {
    css: css`
        gap: 8px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    `,
};
imageBadgeStyles.imageItem = {
    css: css`
        max-width: 23px;
        max-height: 23px;
        flex-basis: 23px;
    `,
};
